<template>
  <section
    data-component="hcAboutRelevant"
    :data-visibility="visibility"
    class="about-subsection"
  >
    <template v-if="visibility === 'mobile'">
      <div class="graphic">
        <div class="quadrant-l">
          <div class="subquadrant-tl">
            <div class="placeholder black"></div>
            <img src="@/content/about/images/jolt.svg" alt="">
          </div>
          <div class="subquadrant-tr">
            <div class="placeholder blue"></div>
          </div>
          <div class="subquadrant-bl">
            <div class="placeholder yellow"></div>
          </div>
          <div class="subquadrant-br">
            <div class="placeholder white"></div>
            <img src="@/content/about/images/pie.svg" alt="">
          </div>
        </div>
        <div class="quadrant-r">
          <div class="placeholder black"></div>
          <img src="@/content/about/images/lightbulb.svg" alt="">
        </div>
      </div>
      <div class="content">
        <div class="content__container">
          <span>01</span>
          <h1 class="h1">
            Make it
            <br />
            Relevant
          </h1>
          <p>
            Empathy is a powerful motivational force that turns good ideas into exceptional experiences.  We root our design process in compelling research to solve for the right problems, and turn big-picture ideas into unforgettable products. It’s our human-first approach that inspires us to deliver work that’s unexpected, complex, and deeply thoughtful.
          </p>
          <div class="headline">
            <span data-ornament="rectangle" />
            <h2 class="h2">
              Services
            </h2>
          </div>
          <ul class="services">
            <li class="service">Ideation Workshops</li>
            <li class="service">Ethnographic Research</li>
            <li class="service">Market Strategy</li>
            <li class="service">Customer Journey Maps</li>
            <li class="service">Competitive Analysis</li>
            <li class="service">Scenarios &amp; Storyboards</li>
          </ul>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="content__anchor" id="hcAboutRelevant"></div>
      <ScrollItem :id="`aboutRelevant_component_top`">
        <div data-anchor="aboutRelevant_component_top"></div>
      </ScrollItem>
      <div
        class="content"
        :class="contentFixed"
      >
        <div class="content__container" :style="contentOpacity">
          <span class="tab-number">01</span>
          <h1 class="h1">
            Make it
            <br />
            Relevant
          </h1>
          <p>
            Empathy is a powerful motivational force that turns good ideas into exceptional experiences.  We root our design process in compelling research to solve for the right problems, and turn big-picture ideas into unforgettable products. It’s our human-first approach that inspires us to deliver work that’s unexpected, complex, and deeply thoughtful.
          </p>
          <div class="headline">
            <span data-ornament="rectangle" />
            <h2 class="h2">
              Services
            </h2>
          </div>
          <ul class="services">
            <li class="service">Ideation Workshops</li>
            <li class="service">Ethnographic Research</li>
            <li class="service">Market Strategy</li>
            <li class="service">Customer Journey Maps</li>
            <li class="service">Competitive Analysis</li>
            <li class="service">Scenarios &amp; Storyboards</li>
          </ul>
        </div>
      </div>
      <div class="graphic" :class="graphicFixed" v-if="visibility==='compact'">
        <div class="quadrant-t">
          <div class="subquadrant-l">
            <div class="placeholder blue"></div>
          </div>
          <div class="subquadrant-r">
            <div class="placeholder black"></div>
            <img src="@/content/about/images/jolt.svg" alt="">
          </div>
        </div>
        <div class="quadrant-m">
          <div class="subquadrant-l">
            <div class="placeholder white"></div>
            <img src="@/content/about/images/pie.svg" alt="">
          </div>
          <div class="subquadrant-r">
            <div class="placeholder yellow"></div>
          </div>
        </div>
        <div class="quadrant-b">
          <div class="placeholder black"></div>
          <img src="@/content/about/images/chart_tall.svg" alt="">
        </div>
      </div>
      <div class="graphic" :class="graphicFixed" v-if="visibility === 'full'">
        <div class="quadrant-tl">
          <div class="placeholder black"></div>
          <img src="@/content/about/images/lightbulb.svg" alt="">
        </div>
        <div class="quadrant-tr">
          <div class="subquadrant-tl">
            <div class="placeholder blue"></div>
          </div>
          <div class="subquadrant-tr">
          <div class="placeholder black"></div>
            <img src="@/content/about/images/jolt.svg" alt="">
          </div>
          <div class="subquadrant-bl">
          <div class="placeholder yellow"></div>
            <img src="@/content/about/images/pie.svg" alt="">
          </div>
          <div class="subquadrant-br">
            <div class="placeholder yellow"></div>
          </div>
        </div>
        <div class="quadrant-bl">
          <div class="placeholder blue"></div>
          <img src="@/content/about/images/eye2eye_tall.svg" alt="">
        </div>
        <div class="quadrant-br">
          <div class="placeholder black"></div>
          <img src="@/content/about/images/chart_tall.svg" alt="">
        </div>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: 'component_hcAboutRelevant',
  props: ['scrollState', 'visibility', 'percentScrolled'],
  computed: {
    contentOpacity: function() {
      let opacity = 0;
      let pointerEvents = 'none';

      const percentScrolled = this.percentScrolled;

      if (percentScrolled < 75) {
        opacity = 0;
      } else if (percentScrolled < 100) {
        opacity = (percentScrolled - 75) / 25;
        pointerEvents = 'auto';
      } else if (percentScrolled < 125) {
        opacity = 1;
        pointerEvents = 'auto';
      } else if (percentScrolled < 187.5) {
        opacity = 1 - ((percentScrolled - 125) / 62.5);
      }

      return {
        opacity: opacity,
        pointerEvents: pointerEvents,
      };
    },
    graphicFixed: function () {
      const classes = {
        following: false,
        'fixed--bottom': false,
      };

      const top = this.scrollState.aboutRelevant_component_top;
      const bot = this.scrollState.bottomOfAboutContent;

      if (!top || !bot) {
        return classes;
      }

      if (top.isAboveViewport && bot.isBelowViewport) {
        classes.following = true;
      } else if (top.isAboveViewport && !bot.isBelowViewport) {
        classes['fixed--bottom'] = true;
      }

      return classes;
    },
    contentFixed: function() {
      const classes = {
        fixed: false,
        'fixed--bottom': false,
      };

      const top = this.scrollState.aboutRelevant_component_top;
      const bot = this.scrollState.bottomOfAboutContent;

      if (!top || !bot) {
        return classes;
      }

      if (top.isAboveViewport && bot.isBelowViewport) {
        classes.fixed = true;
      } else if (top.isAboveViewport && !bot.isBelowViewport) {
        classes['fixed--bottom'] = true;
      }

      return classes;
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';

[data-component="hcAboutRelevant"] {
  [data-anchor="aboutRelevant_component_top"] {
    position: absolute;
    top: 0;
  }

  &[data-visibility="mobile"] {
    .graphic {
      .quadrant-l {
        grid-column: 1 / span 1;

        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;

        .subquadrant-tl {
          grid-column: 1 / span 1;
          grid-row:  1 / span 1;
        @include imageRatio();
        }

        .subquadrant-tr {
          grid-column: 2 / span 1;
          grid-row: 1 / span 1;
        }

        .subquadrant-bl {
          grid-column: 1 / span 1;
          grid-row: 2 / span 1;
        }

        .subquadrant-br {
          grid-column: 2 / span 1;
          grid-row: 2 / span 1;
        }
      }

      .quadrant-r {
        grid-column: 2 / span 1;
      }
    }
  }

  &[data-visibility="compact"] {
    height: 125vh;

    .graphic {
      .quadrant-t {
        grid-column: 1 / span 2;
        grid-row: 1 / span 1;

        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr;
        .subquadrant-l {
          @include imageRatio();;
          grid-column: 1 / span 1;
          grid-row: 1 / span 1;
        }

        .subquadrant-r {
          @include imageRatio();;
          grid-column: 2 / span 1;
          grid-row: 1 / span 1;
        }
      }

      .quadrant-m {
        grid-column: 1 / span 2;
        grid-row: 2 / span 1;

        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr;
        .subquadrant-l {
          @include imageRatio();;
          grid-column: 1 / span 1;
          grid-row: 1 / span 1;
        }

        .subquadrant-r {
          @include imageRatio();;
          grid-column: 2 / span 1;
          grid-row: 1 / span 1;
        }
      }

      .quadrant-b {
        grid-column: 1 / span 2;
        grid-row: 3 / span 3;
      }
    }
  }

  &[data-visibility="full"] {
    height: 125vh;

    .graphic {
      // top left quadrant - one image, square
      .quadrant-tl {
        @include imageRatio();;
        grid-column: 1 / span 1;
        grid-row: 1 / span 2;

        backface-visibility: hidden;
      }

      // top right quadrant - 4 square images
      .quadrant-tr {
        grid-column: 2 / span 1;
        grid-row: 1 / span 2;

        display: grid;
        grid-template-rows: 1fr 1fr;
        grid-template-columns: 1fr 1fr;

        .subquadrant-tl {
          grid-column: 1 / span 1;
          grid-row:  1 / span 1;
        }

        .subquadrant-tr {
          grid-column: 2 / span 1;
          grid-row:  1 / span 1;
        }

        .subquadrant-bl {
          grid-column: 1 / span 1;
          grid-row:  2 / span 1;
        }

        .subquadrant-br {
          grid-column: 2 / span 1;
          grid-row:  2 / span 1;
        }
      }

      // bottom left quadrant - one image
      .quadrant-bl {
        grid-column: 1 / span 1;
        grid-row: 3 / span 3;
      }

      // bottom right quadrant - one image
      .quadrant-br {
        grid-column: 2 / span 1;
        grid-row: 3 / span 3;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/int_hcAboutRelevant.vue